import { updateObject } from "../../../../shared";
import { brandPerformanceConstants } from "../../../shared-screens/constants";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  groupPerformanceConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const { ALL_GROUP_RESPONSE_DATA, CUSTOMER_RESPONSES_EXPORT_ALL_DATA } =
  groupPerformanceConstants;

const { GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING } =
  brandPerformanceConstants;

const initialState = {
  allItemsForExport: [],
  franchiseResponsesData: [],
  allFranchiseResponsesData: [],
  groupResponseDataPagination: {
    ...PAGINATION_DEFAULTS,
  },
  groupsAvgSentimentAndTransactionRatingData: {},
};

export const groupPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_GROUP_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allFranchiseResponsesData: action.data.pageData,
        franchiseResponsesData: action.data.pageData.result,
        groupResponseDataPagination: action.data.page,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        groupsAvgSentimentAndTransactionRatingData: action.data,
      });
    default:
      return state;
  }
};
